import classNames from 'classnames';
import React from 'react';
import './ChatBlasterPreviewByChannels.pcss';
import { ArrayItemType } from '@mm/utils';
import { Alert } from '@mm/components';
import { PlatformType } from '@mm/state/model/CampaignsModel';
import { DialoguePreview } from '../../../../../../modules/DailoguePreview/DialoguePreview';
import { SmsIphonePreview } from '../../../components/SmsIphonePreview/SmsIphonePreview';

export const PreviewChannelOptions = [
  'facebook',
  'sms',
  'webchat',
  'instagram',
] as const;

export type PreviewChannelOption = ArrayItemType<typeof PreviewChannelOptions>;

export const PreviewChannelOptionLabels: Record<PreviewChannelOption, string> =
  {
    facebook: 'Messenger',
    sms: 'SMS',
    webchat: 'Webchat',
    instagram: 'Instagram',
  };

type ChatBlasterPreviewByChannelsProps = {
  className?: string;
  activePreview: string;
  channels?: PlatformType[] | undefined;
  setActivePreview: (channel: PreviewChannelOption) => void;
  link: string;
  onSaveCampaign: () => void;
  dialogueId?: number;
  campaignId?: number;
  schedulerId?: number;
  activeTestNumbers?: string[];
  platforms?: PlatformType[];
};

export const ChatBlasterPreviewByChannels = (
  props: ChatBlasterPreviewByChannelsProps,
) => {
  const {
    activePreview,
    channels,
    setActivePreview,
    className,
    dialogueId,
    campaignId,
    schedulerId,
    activeTestNumbers,
    onSaveCampaign,
    platforms,
  } = props;

  return (
    <div
      className={classNames(
        className,
        'chat-blaster-preview-by-channels--active',
        {
          'chat-blaster-preview-by-channels--inactive': !channels?.length,
        },
      )}
    >
      <div className="chat-blaster-preview-by-channels__channel-options">
        {channels?.map(c => (
          <div
            key={c}
            className={classNames(
              'chat-blaster-preview-by-channels__channel-option',
              {
                'chat-blaster-preview-by-channels__channel-option--selected':
                  activePreview === c,
              },
            )}
            onClick={() => setActivePreview(c as PreviewChannelOption)}
          >
            {PreviewChannelOptionLabels[c]} Preview
          </div>
        ))}
      </div>
      {activePreview === 'facebook' && (
        <div className="chat-blaster-preview-by-channels__facebook-preview">
          {dialogueId && (
            <DialoguePreview
              dialogueId={dialogueId}
              style={{ top: -20, marginTop: 20 }}
              sticky
            />
          )}
        </div>
      )}
      {activePreview === 'sms' && (
        <SmsIphonePreview
          className="chat-blaster-preview-by-channels__phone-preview"
          campaignId={campaignId}
          schedulerId={schedulerId}
          schedulerIndex={0}
          activeTestNumbers={activeTestNumbers}
          onSaveCampaign={onSaveCampaign}
          destinationPageId={dialogueId}
        />
      )}
    </div>
  );
};
